<!--通用弹窗-->
<template>
  <Modal
    v-model="modalVisible"
    :title="title ? title : '提示'"
    :mask-closable="false"
    :width="modalWidth ? modalWidth : 532"
    :z-index="2000"
    @on-cancel="closeModal"
  >
    <div class="text-14">
      <div v-html="noticeContent" />
    </div>
    <div slot="footer">
      <Button
        v-if="btnOk.showBtn"
        type="primary"
        size="large"
        @click="handleOk"
      >
        {{ btnOk.text }}
      </Button>
      <Button v-if="btnCancel.showBtn" size="large" @click="handleCancel">
        {{ btnCancel.text }}
      </Button>
    </div>
  </Modal>
</template>

<script>
import { Modal, Button } from 'iview';
import { mapState } from 'vuex';

export default {
  name: 'CommonNoticeDialog',
  components: {
    Modal, Button
  },
  data() {
    return {
      modalVisible: false,
    };
  },
  computed: {
    ...mapState({
      showModal: (state) => state.globalModal.commonNoticeDialogOpt.visible,
      title: (state) => state.globalModal.commonNoticeDialogOpt.title,
      noticeContent: (state) => state.globalModal.commonNoticeDialogOpt.content,
      modalWidth: (state) => state.globalModal.commonNoticeDialogOpt.width,
      btnOk: (state) => state.globalModal.commonNoticeDialogOpt.ok,
      btnCancel: (state) => state.globalModal.commonNoticeDialogOpt.cancel,
    }),
  },
  watch: {
    showModal(val) {
      this.modalVisible = val;
    },
  },
  methods: {
    closeModal() {
      this.$store.commit('globalModal/closeCommonNoticeDialog');
    },
    handleOk() {
      this.closeModal();
      this.btnOk?.handler();
    },
    handleCancel() {
      this.closeModal();
      this.btnCancel?.handler();
    },
  }
};
</script>
